module.exports = __webpack_public_path__ + "img/sails.3bbc964e.svg";